/** The filename a download response asks for; the server owns the scheme, so the link must not
 *  restate it. Readable only because the endpoint sets `Access-Control-Expose-Headers`. */
export function filenameFromResponse(res, fallback) {
    const header = res?.headers?.['content-disposition']
        ?? res?.headers?.['Content-Disposition'];
    if (!header) return fallback;

    // RFC 5987 first: it carries the encoded, non-ASCII-safe name.
    const encoded = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(header);
    if (encoded) {
        try {
            return decodeURIComponent(encoded[1].trim().replace(/^"|"$/g, '')) || fallback;
        } catch {
            // A malformed escape must not cost the download its name.
        }
    }
    const plain = /filename="?([^";]+)"?/i.exec(header);
    return plain ? plain[1].trim() || fallback : fallback;
}
